import { ThemeOptions } from "@mui/material";

const palette: Exclude<ThemeOptions["palette"], undefined> = {
  background: {
    default: "#F1F1F1",
    paper: "#FFFFFF",
  },
  primary: {
    main: "#006A4D",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#11B67A",
    contrastText: "#FFFFFF",
  },
  success: {
    main: "#10B981",
  },
  error: {
    main: "#EF4035",
  },
  action: {
    active: "#006A4D",
  },
  text: {
    primary: "#000000",
    secondary: "#323233",
    disabled: "#C9C9C9",
  },
};

export default palette;
